export default __webpack_public_path__ + "static/xero-connect-9878573cfbbc1891f63dfdf05092a8d3.svg";